import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  collection,
  query,
  where,
  getDocs,
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";

import emailjs from "@emailjs/browser";
import Swal from "sweetalert2";

const firebaseConfig = {
  apiKey: "AIzaSyD6tPqy42tN6uF3RoLlx87IimxXWVCbFWs",
  authDomain: "sport-league-e35d7.firebaseapp.com",
  projectId: "sport-league-e35d7",
  storageBucket: "sport-league-e35d7.appspot.com",
  messagingSenderId: "515296229458",
  appId: "1:515296229458:web:51917438056a955ce9878b",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

const logInWithEmailAndPassword = async (email, password, t) => {
  try {
    await signInWithEmailAndPassword(auth, email, password).then(
      (userCredential) => {
        const user = userCredential.user;
        // store basic auth user
        try {
          localStorage.setItem("user", JSON.stringify(user));
        } catch (e) {
          // ignore
        }
        // eslint-disable-next-line
        import("./logger").then(({ info }) => info(user));
        // Try to cache the full user document from Firestore (if present)
        (async () => {
          try {
            const userRef = query(
              collection(db, "users"),
              where("uid", "==", user.uid)
            );
            const found = await getDocs(userRef);
            if (found && found.docs && found.docs.length > 0) {
              const userDoc = found.docs[0].data();
              try {
                localStorage.setItem("userDocument", JSON.stringify(userDoc));
              } catch (e) {
                // ignore
              }
            }
          } catch (e) {
            // ignore
          }
        })();
      }
    );
  } catch (err) {
    console.error(err);
    Swal.fire({
      text: t ? t("loginError") : "Login error",
      icon: "error",
      confirmButtonColor: "#005EE1",
      confirmButtonText: "OKAY",
    });
  }
};

const registerWithEmailAndPassword = async (
  email,
  password,
  username,
  firstName,
  lastName,
  country,
  phoneNumber,
  dateOfBirth,
  gender,
  language,
  bannerDesktop,
  bannerMobile,
  tickets,
  starCoins,
  keys,
  hasLogeedIn,
  t
) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;

    const userRef = query(
      collection(db, "users"),
      where("usernameForVerification", "==", username)
    );
    const findUsers = await getDocs(userRef);

    findUsers.forEach(async (userObject) => {
      const getUser = doc(db, "users", userObject.id);
      await updateDoc(getUser, {
        uid: user.uid,
        email,
        username,
        firstName,
        lastName,
        country,
        phoneNumber,
        dateOfBirth,
        gender,
        language,
        bannerDesktop,
        bannerMobile,
        tickets,
        starCoins,
        keys,
        hasLogeedIn,
        dateCreated: serverTimestamp(),
        userHasFinishedWelcomeTutorial: false,
        userHasFinishedShopTutorial: false,
        userHasFinishedPlayTutorial: false,
      });
    });

    const serviceId = "sportleague_outlook";
    const templateId = "newUserAdmin";
    const publicKey = "Ki5BETKiWrS6RDEP_";

    const templateParams = {
      newUserEmail: email,
      newUserUsername: username,
    };

    await emailjs.send(serviceId, templateId, templateParams, publicKey).then(
      (response) => {
        // eslint-disable-next-line
        import("./logger").then(({ info }) =>
          info("SUCCESS!", response.status, response.text)
        );
      },
      (error) => {
        // eslint-disable-next-line
        import("./logger").then(({ error }) => error("FAILED...", error));
      }
    );

    // await addDoc(collection(db, "mail"), {
    //   to: [
    //     'info@sportleague.net'
    //   ],
    //   message: {
    //     subject: 'Nuevo usuario registrado!',
    //     html: `Hola!<br/><br/>Se ha registrado un nuevo usuario con el email ${email} y el nombre de usuario ${username}!<br/><br/>
    //           Saludos,<br/>
    //           Sport League`
    //   }
    // });
  } catch (err) {
    console.error(err);
    Swal.fire({
      text: t ? t("registrationError") : "Registration error",
      icon: "error",
      confirmButtonColor: "#005EE1",
      confirmButtonText: "OKAY",
    });
  }
};

// const registerWithEmailAndPassword = async (email, password, username, firstName, lastName, country, phoneNumber, dateOfBirth, gender) => {
//   try {
//     const res = await createUserWithEmailAndPassword(auth, email, password);
//     const user = res.user;
//     await addDoc(collection(db, "users"), {
//       uid: user.uid,
//       email,
//       username,
//       firstName,
//       lastName,
//       country,
//       phoneNumber,
//       dateOfBirth,
//       gender,
//       bannerDesktop: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FLogo%20Banners%2Fdesktop%2FBanner%20Spl.png?alt=media&token=5ede99d8-083f-4754-9d53-66579e01dbfa',
//       bannerMobile: 'https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fbanners%2FLogo%20Banners%2Fmobile%2FBanner%20Sp01.png?alt=media&token=8ecfa527-ec54-41f9-830d-cf495eeef53e',
//       tickets: 150,
// 			keys: 3
//     });

//     await addDoc(collection(db, "mail"), {
//       to: [
//         'info@sportleague.net'
//       ],
//       message: {
//         subject: 'Nuevo usuario registrado!',
//         html: `Hola!<br/><br/>Se ha registrado un nuevo usuario con el email ${email} y el nombre de usuario ${username}!<br/><br/>
//               Saludos,<br/>
//               Sport League`
//       }
//     });
//   } catch (err) {
//     console.error(err);
//     alert(err.message);
//   }
// };

const sendPasswordReset = async (email, t) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    Swal.fire({
      text: t ? t("passwordResetError") : "Password reset error",
      icon: "error",
      confirmButtonColor: "#005EE1",
      confirmButtonText: "OKAY",
    });
  }
};

const logout = () => {
  try {
    clearLocalUserCache();
  } catch (e) {
    // ignore
  }
  signOut(auth);
};

// Clear local cache when logging out
const clearLocalUserCache = () => {
  try {
    localStorage.removeItem("user");
    localStorage.removeItem("userDocument");
  } catch (e) {
    // ignore
  }
};

export {
  auth,
  db,
  storage,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordReset,
  logout,
};
